import axios from '../request/http.js'

class Supplier {
  /* 供应商管理列表集合 */
  static getSupplierList(queryStr) {
    let url = `/zzd/api/back/supplier/list?queryStr=${queryStr}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 冻结供应商 */
  static postFrozenSupplier(data) {
    let url = `/zzd/api/back/supplier/frozen`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除供应商 */
  static postDelSupplier(data) {
    let url = `/zzd/api/back/supplier/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 修改供应商密码 */
  static postModSupplierPsw(data) {
    let url = `/zzd/api/back/supplier/update/pwd`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 新增供应商 */
  static postAddSupplier(data) {
    let url = `/zzd/api/back/supplier/save`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 编辑供应商 */
  static postModSupplier(data) {
    let url = `/zzd/api/back/supplier/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Supplier;